import { Fade, Slide } from "@mui/material";

import "./style.scss";

const SlantModal = ({ children, closeModal, openModal = true }) => {
  return (
    <Fade in={openModal}>
      <div
        onClick={(e) => e.target === e.currentTarget && closeModal()}
        className="pd-modal slant"
      >
        <Slide direction="up" in={openModal} mountOnEnter unmountOnExit>
          <div className="popBox2">
            <div className="modal_cover">{children}</div>
          </div>
        </Slide>
      </div>
    </Fade>
  );
};

export default SlantModal;
